module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/58a85d2a2e017c3d519aed798e504ce6.png";